const transparent = {
  backgroundColor: 'transparent',
};

const transparentDarkGray = {
  backgroundColor: 'rgba(51, 51, 51, .8)',
};

const transparentHovered = {
  backgroundColor: 'rgba(0, 0, 0, .06)',
};
const transparentFocused = transparentHovered;

const transparentActive = {
  backgroundColor: 'rgba(0, 0, 0, .1)',
};

const transparentDarkGrayHovered = {
  backgroundColor: 'rgba(51, 51, 51, 1.0)',
};
const transparentDarkGrayFocused = transparentDarkGrayHovered;

const transparentDarkGrayActive = {
  backgroundColor: 'rgba(51, 51, 51, 1.0)',
};

const white = {
  backgroundColor: 'rgba(255, 255, 255, .9)',
};

const whiteHovered = {
  backgroundColor: 'rgba(255, 255, 255, 1.0)',
};
const whiteFocused = whiteHovered;

const whiteActive = {
  backgroundColor: 'rgba(255, 255, 255, 1.0)',
};

const lightGray = {
  backgroundColor: 'rgba(239, 239, 239, .9)',
};

const lightGrayHovered = {
  backgroundColor: 'rgba(239, 239, 239, 1.0)',
};
const lightGrayFocused = lightGrayHovered;

const lightGrayActive = {
  backgroundColor: 'rgba(239, 239, 239, 1.0)',
};

const gray = {
  color: 'rgba(142 ,142, 142, .9)',
};

const grayHovered = {
  backgroundColor: 'rgba(142 ,142, 142, 1.0)',
};
const grayFocused = grayHovered;

const grayActive = {
  backgroundColor: 'rgba(142 ,142, 142, 1.0)',
};

const red = {
  backgroundColor: 'rgba(230, 0, 35, .9)',
};

const redHovered = {
  backgroundColor: 'rgba(230, 0, 35, 1.0)',
};
const redFocused = redHovered;
const redActive = redHovered;

export default {
  transparent,
  transparentDarkGray,
  transparentHovered,
  transparentFocused,
  transparentActive,
  transparentDarkGrayHovered,
  transparentDarkGrayFocused,
  transparentDarkGrayActive,
  white,
  whiteHovered,
  whiteFocused,
  whiteActive,
  lightGray,
  lightGrayHovered,
  lightGrayFocused,
  lightGrayActive,
  gray,
  grayHovered,
  grayFocused,
  grayActive,
  red,
  redActive,
  redFocused,
  redHovered,
};
